export interface HTMLAiTextAreaElement extends HTMLElement {
  value: string;
  focus: () => void;
  blur: () => void;
}
